/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { Button, Icon } from 'learning-panel-components';
import { FC } from 'react';
import { translate } from 'translations';
import styles from './videoTutorialsBanner.module.scss';

const VideoTutorialBanner: FC<VideoTutorialBannerProps> = (props: VideoTutorialBannerProps) => {
    const { name, description, duration, uuid, status, month, potentialPoints, onClick } = props;

    return (
        <div>
            <div className={styles['video-banner']}>
                <div className={styles['inner-wrapper']}>
                    <div className={styles.tag}>{translate(month)}</div>
                    <div className={styles['video-background']}></div>
                    <div className={styles['left-wrapper']}>
                        <div className={styles['top-wrapper']}>
                            <Icon name={'videoLearningPanel'} className={styles['video-icon']} />
                            <div className={styles['video-icon-text']}>{translate('VIDEO')}</div>
                        </div>
                        <div className={styles['name-wrapper']}>
                            <div className={styles.name} title={translate(name)}>
                                {translate(name)}
                            </div>
                        </div>
                        <div className={styles.description} title={translate(description)}>
                            {translate(description)}
                        </div>
                        <div>
                            <div className={styles['button-wrapper']}>
                                <Button
                                    onClick={() => onClick(uuid)}
                                    type="bigGradient"
                                    text={translate(status === 'notStarted' ? 'Watch' : 'Continue')}
                                    className={styles.button}
                                    lowerCase
                                />
                            </div>
                        </div>
                    </div>
                    <div className={styles['right-wrapper']}>
                        {potentialPoints && (
                            <>
                                <span className={styles.text}>{`${translate('UpTo')}`}</span>
                                <div className={styles.coins}>
                                    <Icon name="devCoin" className={styles.coin} />
                                    <div className={styles.points}>{potentialPoints?.toLocaleString()}</div>
                                </div>
                                <hr className={styles.line} />
                            </>
                        )}
                        {duration && (
                            <div className={styles.duration}>
                                <Icon name="timeWhite" className={styles['time-icon']} />
                                <span className={styles.text}>{`${duration}`}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export interface VideoTutorialBannerProps {
    name: string;
    description: string;
    duration: string;
    uuid: string;
    status: 'inProgress' | 'completed' | 'notStarted';
    month: string;
    potentialPoints: number;
    onClick: Function;
}

export default VideoTutorialBanner;
